import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import _ from "underscore"
import { Modal, ModalBody } from "../modals/Modal"
import Select from "react-select"
import "../../styles/_verify_candidate_modal.scss"
import "../../styles/_resume_listing_container.scss"
import $ from "jquery"
import {
  reGenerateSummary,
  toggleCandidateDetailsModal,
  fetchCandidateDetails,
  updateCandidateDetails,
} from "../../actions/actions"
import Loader from "../components/Loader"
import {
  skillSelectStyles,
  newSkillSelectStyles,
  personalFieldSelectStyles,
  skillOptions,
} from "../../services/helpers"
import ImageUploader from "./ImageUploader"

const CandidateDetailsVerification = (props) => {
  const { isOpen } = props
  const ref = useRef(null)
  const textArearef = useRef(null)
  const dispatch = useDispatch()
  const candidateDetails = useSelector((state) => state.candidateDetails)

  const [isDeleteSkillModalOpen, setdeleteSkillModalOpen] = useState(false)
  const [isBulkDeleteSkillModalOpen, setBulkdeleteSkillModalOpen] =
    useState(false)

  const [isAddNewSkillPopupOpen, setAddNewSkillPopupOpen] = useState(false)
  const [showRegenerateSummaryPopup, setRegenerateSummaryPopup] =
    useState(false)
  const [summaryText, setSummaryText] = useState("")

  const [newSkillValue, setNewSkillValue] = useState("")
  const [newSkills, setNewSkills] = useState([])
  const [skillsSortType, setSkillsSortType] = useState("high")
  const [isBulkDelete, setBulkDelete] = useState(false)
  const [skillIds, setSkillIds] = useState([])

  const [skillIndex, setSkillIndex] = useState(null)
  const [data, setData] = useState({})
  const [mappingData, setMappingData] = useState([])
  let resumeId = candidateDetails.resumeId
  let builderId = candidateDetails.builderId
  let showEditText = candidateDetails.showEditText
  let isVerifyBtnDisabled = true
  let skillsLimitReached = false

  ///set data and mapping data upon fetching candidate details
  useEffect(() => {
    if (_.isEmpty(candidateDetails.data))
      dispatch(fetchCandidateDetails(resumeId))
  }, [])

  useEffect(() => {
    if (candidateDetails.logosUpdated) {
      let temp = $.extend(true, {}, data)
      temp.images = candidateDetails.data.images
      setData(temp)
      return
    }
    let temp = candidateDetails.data || {}
    if (temp?.skills?.skills) {
      temp.skills.skills = sortSkillsHigh(temp.skills.skills)
    }
    setData(temp)
    setTimeout(() => {
      adjustSummaryTextHeight()
    }, 100)
  }, [candidateDetails.data])

  useEffect(() => {
    setMappingData(
      candidateDetails.mappingData
        ? candidateDetails.mappingData[builderId] || []
        : []
    )
  }, [candidateDetails.mappingData])

  /// update summary text upon regenerate
  useEffect(() => {
    if (candidateDetails.summaryFetched && candidateDetails.summary) {
      $(".main-container")?.scrollTop(0)
      updateSummaryText(candidateDetails.summary)
      adjustSummaryTextHeight()
    }
  }, [candidateDetails.summary])

  ///handle click outside add new skills popup
  useEffect(() => {
    const element = ref.current
    element?.addEventListener("click", handleClickOutside)
    return () => {
      element?.removeEventListener("click", handleClickOutside)
    }
  }, [isAddNewSkillPopupOpen, showRegenerateSummaryPopup])

  useEffect(() => {
    if (isDeleteSkillModalOpen || isBulkDeleteSkillModalOpen) {
      $(".modal-backdrop")?.css("opacity", 1)
      $(".verify-candidate-details-modal")?.css("opacity", 0.6)
      $(".bottom-container")?.css("opacity", 0.6)
    } else {
      $(".modal-backdrop")?.css("opacity", 0.6)
      $(".verify-candidate-details-modal")?.css("opacity", 1)
      $(".bottom-container")?.css("opacity", 1)
    }
  }, [isDeleteSkillModalOpen || isBulkDeleteSkillModalOpen])

  const handleClickOutside = (event) => {
    let target = $(event.target)
    if (
      isAddNewSkillPopupOpen &&
      !target.closest(".add-new-skill-popup").length
    ) {
      setAddNewSkillPopupOpen(false)
    }
    if (
      showRegenerateSummaryPopup &&
      !target.closest(".regenerate-summary-popup").length
    ) {
      setRegenerateSummaryPopup(false)
    }
  }

  const updateSummaryText = (text) => {
    let temp = $.extend(true, {}, data)
    if (temp?.summary?.summary) temp.summary.summary = text
    setData(temp)
  }

  const openDeleteSkillPopup = (index) => {
    setdeleteSkillModalOpen(true)
    setSkillIndex(index)
  }

  const deleteSkill = () => {
    let temp = $.extend(true, {}, data)
    if (skillIndex > -1) temp["skills"].skills.splice(skillIndex, 1)
    setData(temp)
    closeDeleteSkillPopup()
  }

  const closeDeleteSkillPopup = () => {
    setdeleteSkillModalOpen(false)
    setBulkdeleteSkillModalOpen(false)
    setSkillIndex(null)
  }

  const handleClose = (save = false) => {
    dispatch(toggleCandidateDetailsModal({ isOpen: false, resumeId: null }))
    if (save) {
      dispatch(updateCandidateDetails(resumeId, data, true))
    }
  }

  const updatePersonalInformation = (item, value) => {
    let temp = $.extend(true, {}, data)
    temp.personal_information[item] = value
    setData(temp)
  }

  const handleChangePersonalInfoValue = (item, value) => {
    let temp = $.extend(true, {}, data)
    temp.personal_information[item] = value.value
    setData(temp)
  }

  const getPersonalInformationFieldInfo = (item) => {
    let title = item,
      value = "",
      placeholder = item,
      isRequired = false,
      isDropdown = false,
      dropDownOptions = []
    if (data.personal_information[item]) value = data.personal_information[item]
    _.map(mappingData, (data) => {
      if (data.section === "personal_information") {
        let fieldsData = !_.isEmpty(data.fields) ? data.fields : []
        _.map(fieldsData, (field) => {
          if (field.backend_name === item) {
            if (field.display) title = field.display
            if (field.placeholder) placeholder = field.placeholder
            if (field.is_mandatory) isRequired = true
            if (field.dropdown_options) {
              isDropdown = true
              _.map(field.dropdown_options, (option) => {
                dropDownOptions.push({ value: option, label: option })
              })
            }
          }
        })
      }
    })
    return {
      title,
      value,
      placeholder,
      isRequired,
      isDropdown,
      dropDownOptions,
    }
  }

  const getSummarySkillsInfo = () => {
    let summarySkillsInfo = { summary: {}, skills: {} }
    _.map(mappingData, (data) => {
      let fieldsData = !_.isEmpty(data.fields) ? data.fields : []
      if (
        ["summary", "skills"].includes(data.section) &&
        !_.isEmpty(fieldsData)
      ) {
        _.map(fieldsData, (field) => {
          if (field.backend_name === data.section) {
            summarySkillsInfo[data.section].title = field.display
            summarySkillsInfo[data.section].isRequired = field.is_mandatory
            if (data.section === "skills" && field.max_limit)
              summarySkillsInfo["skills"].maxLimit = field.max_limit
          }
        })
      }
    })
    return summarySkillsInfo
  }

  const handleNewSkillChange = (e) => {
    setNewSkillValue(e.target.value)
  }

  const handleNewSkillLevel = (val, index) => {
    let temp = $.extend(true, [], newSkills)
    if (temp[index]) {
      temp[index].level = val.value
    }
    setNewSkills(temp)
  }

  const isNewSkillPopupSubmitBtnDisabled = () => {
    if (_.isEmpty(newSkills)) return true
    let disabled = false
    newSkills.forEach((skill) => {
      if (!skill.level) {
        disabled = true
        return
      }
    })
    return disabled
  }

  const handleNewSkillSubmit = () => {
    let temp = $.extend(true, {}, data)
    if (_.isEmpty(temp.skills)) temp.skills = {}
    if (_.isEmpty(temp.skills.skills)) temp.skills.skills = []
    temp.skills.skills = [...temp.skills.skills, ...newSkills]
    setData(temp)
    setAddNewSkillPopupOpen(false)
    setNewSkills([])
  }

  const handleSkillLevelChange = (value, index) => {
    let temp = $.extend(true, {}, data)
    if (temp["skills"]?.skills[index]) {
      temp["skills"].skills[index].level = value.value
    }
    setData(temp)
  }

  const handleGenerateSummary = (text) => {
    dispatch(reGenerateSummary(resumeId, text, summaryText))
  }

  const handleCandidateDetailsUpdate = () => {
    dispatch(updateCandidateDetails(resumeId, data))
    handleClose()
  }

  let newSkillPopupSubmitBtnDisabled = isNewSkillPopupSubmitBtnDisabled()
  let addNewSkillBtnPosition = $(".add-new-skill")?.offset() || {}
  let { summary, skills } = getSummarySkillsInfo()
  let showLoader = candidateDetails.fetching

  const getpersonalInfoFields = () => {
    let personalInfoFields = [],
      requiredPersonalFields = []
    _.map(mappingData, (data) => {
      if (data.section === "personal_information") {
        let fieldsData = !_.isEmpty(data.fields) ? data.fields : []
        _.map(fieldsData, (field) => {
          personalInfoFields.push(field.backend_name)
          if (field.is_mandatory)
            requiredPersonalFields.push(field.backend_name)
        })
      }
    })
    return { personalInfoFields, requiredPersonalFields }
  }

  const sortSkillsHigh = (skills) => {
    let levelMapping = { beginner: 1, intermediate: 2, advanced: 3 }
    if (_.isEmpty(skills)) return []
    let sortedSkills = $.extend(true, [], skills).sort((s1, s2) =>
      levelMapping[s1.level] < levelMapping[s2.level]
        ? 1
        : levelMapping[s1.level] > levelMapping[s2.level]
        ? -1
        : 0
    )
    return sortedSkills
  }

  const sortSkillsLow = (skills) => {
    let levelMapping = { beginner: 1, intermediate: 2, advanced: 3 }
    if (_.isEmpty(skills)) return []
    let sortedSkills = $.extend(true, [], skills).sort((s1, s2) =>
      levelMapping[s1.level] > levelMapping[s2.level]
        ? 1
        : levelMapping[s1.level] < levelMapping[s2.level]
        ? -1
        : 0
    )
    return sortedSkills
  }

  const handleChangeSummary = (text) => {
    let temp = $.extend(true, {}, data)
    if (temp?.summary) {
      temp.summary.summary = text
    }
    setData(temp)
    adjustSummaryTextHeight()
  }

  const adjustSummaryTextHeight = () => {
    let element = textArearef.current
    if (element) {
      element.style.height = "1px"
      element.style.height = element.scrollHeight - 46 + "px"
    }
  }

  const bulkSkillsDelete = () => {
    let temp = $.extend(true, {}, data)
    let newSkillsList = []
    _.map(data?.skills?.skills, (skill, id) => {
      if (!skillIds.includes(id)) newSkillsList.push(data["skills"].skills[id])
    })
    temp["skills"].skills = newSkillsList
    setData(temp)
    setSkillIds([])
    setBulkDelete(false)
    setBulkdeleteSkillModalOpen(false)
  }

  const renderCandidateDetailsContainer = (limit) => {
    if (showLoader)
      return (
        <div className="candidate-details-loading-container">
          <Loader className={"align-top"} />
        </div>
      )
    if (_.isEmpty(data.personal_information)) return null
    let { personalInfoFields } = getpersonalInfoFields()
    return (
      <div ref={ref} className="main-container">
        <div className="personal-info-edit-container">
          {_.map(personalInfoFields, (item) => {
            let {
              title,
              value,
              placeholder,
              isRequired,
              isDropdown,
              dropDownOptions,
            } = getPersonalInformationFieldInfo(item)
            return (
              <div className="item-container">
                <div className="title">
                  {title} {isRequired ? <span>*</span> : null}
                </div>

                {!isDropdown ? (
                  <input
                    className="item-input"
                    value={value}
                    placeholder={placeholder}
                    onChange={(e) =>
                      updatePersonalInformation(item, e.target.value)
                    }
                    type="text"
                  />
                ) : (
                  <Select
                    className="item-input-dropdown-options"
                    placeholder="Select"
                    value={dropDownOptions.filter(function (option) {
                      return option.value === value
                    })}
                    options={dropDownOptions}
                    styles={personalFieldSelectStyles}
                    onChange={(value) =>
                      handleChangePersonalInfoValue(item, value)
                    }
                  />
                )}
              </div>
            )
          })}
        </div>
        {!_.isEmpty(data["summary"]) ? (
          <div className="summary-container">
            <div className="title">
              {summary.title} {summary.isRequired ? <span>*</span> : null}
            </div>
            <div className="summary-input-container">
              {candidateDetails.summaryFetching ? (
                <div className="summary-loader">
                  <Loader />
                </div>
              ) : (
                <textarea
                  ref={textArearef}
                  className="summary-input"
                  onkeyup="adjustSummaryTextHeight()"
                  onChange={(e) => handleChangeSummary(e.target.value)}
                  value={data.summary.summary || ""}
                />
              )}
              <div
                className="re-generate-btn"
                tabIndex={0}
                onClick={() =>
                  candidateDetails.reGenerationsLeft &&
                  setRegenerateSummaryPopup(true)
                }
                disabled={!candidateDetails.reGenerationsLeft}
              >
                <img
                  src="dist/images/re-generate-icon.svg"
                  alt="regenerate icon"
                />
                Re- Generate ({candidateDetails.reGenerationsLeft} left)
              </div>
              {showRegenerateSummaryPopup ? (
                <div className="regenerate-summary-popup">
                  <div className="heading">
                    What would you like to change?{" "}
                    <span
                      className="icon-cross close-modal-icon"
                      onClick={() => setRegenerateSummaryPopup(false)}
                    />
                  </div>
                  <textarea
                    className="regenerate-textarea-container"
                    value={summaryText}
                    onChange={(e) => {
                      setSummaryText(e.target.value)
                    }}
                  />
                  <div className="btn-container">
                    <button
                      className="regenerate-btn"
                      disabled={!summaryText}
                      onClick={() => {
                        handleGenerateSummary(data.summary?.summary || "")
                        setRegenerateSummaryPopup(false)
                      }}
                    >
                      Re-Generate
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        {!_.isEmpty(data["images"]) ? (
          <div className="logos-container">
            <div className="title">Organisational logo verification</div>
            {_.map(_.keys(data["images"].logos), (company, index) => {
              return (
                <div className="logo-container">
                  <div className="logo-actions-container">
                    <div className="logo-img"></div>
                    <div className="add-logo">
                      <ImageUploader
                        company={company}
                        index={index}
                        imageData={data["images"].logos[company]}
                        resumeId={resumeId}
                      />
                    </div>
                  </div>
                  <div className="logo-details">{company}</div>
                </div>
              )
            })}
          </div>
        ) : null}
        {skills.isRequired ? (
          <div className="skills-container">
            <div className="title">
              {skills.title} {skills.isRequired ? <span>*</span> : null}
              {limit ? (
                <span className="max-limit-warning">(Max {limit} skills)</span>
              ) : null}
              <div
                className={`bulk-delete-skills ${
                  skillIds.length ? "display" : ""
                }`}
                onClick={() => {
                  setBulkdeleteSkillModalOpen(true)
                }}
              >
                Delete Selected Skill(s)
              </div>
              <div className="skill-container add-new-skill">
                <div onClick={() => setAddNewSkillPopupOpen(true)}>
                  +Add New
                </div>
              </div>
            </div>
            <div className="all-skills-container">
              <div className="skill-heading-container skill-container">
                <div className="col-sm-6 skill-details">
                  <div className="skill-detail">
                    <input
                      className="select-skill"
                      type="checkbox"
                      checked={isBulkDelete}
                      onClick={() => {
                        if (isBulkDelete) {
                          setSkillIds([])
                        } else {
                          let temp = [],
                            skillData = data?.skills?.skills || []
                          _.map(skillData, (skill, index) => {
                            temp.push(index)
                          })
                          setSkillIds(temp)
                        }
                        setBulkDelete(!isBulkDelete)
                      }}
                    />
                    Skill Name
                  </div>
                </div>
                <div className="col-sm-3 skill-level">
                  Skill Level
                  <span
                    className={`icon-arrow-down-3 ${
                      skillsSortType === "low" ? "low-type" : ""
                    }`}
                    onClick={() => {
                      let temp = $.extend(true, {}, data)
                      if (temp?.skills?.skills) {
                        temp.skills.skills =
                          skillsSortType === "high"
                            ? sortSkillsLow(temp.skills.skills)
                            : sortSkillsHigh(temp.skills.skills)
                      }
                      setSkillsSortType(
                        skillsSortType === "high" ? "low" : "high"
                      )
                      setData(temp)
                    }}
                  />
                </div>
                <div className="col-sm-2 skill-actions">Actions</div>
              </div>
              {_.map(data?.skills?.skills, (skill, index) => {
                return (
                  <div
                    className={`skill-container ${
                      isAddNewSkillPopupOpen ? "popup-open" : ""
                    }`}
                  >
                    <div className="col-sm-6 skill-details">
                      <div className="skill-detail">
                        <input
                          className="select-skill"
                          type="checkbox"
                          checked={skillIds.includes(index)}
                          onClick={() => {
                            let temp = $.extend(true, [], skillIds)
                            if (!temp.includes(index)) {
                              temp.push(index)
                            } else {
                              let i = temp.indexOf(index)
                              if (i > -1) temp.splice(i, 1)
                            }
                            setSkillIds(temp)
                          }}
                        />
                        <div className="skill-info">
                          <span
                            className={`legend-dot legend-dot-${skill.level}`}
                          />
                          <div className="skill-name">{skill.skill}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-3 skill-level">
                      <div className="select-container">
                        <Select
                          className="skill-select-options"
                          value={skillOptions.filter(function (option) {
                            return option.value === skill.level
                          })}
                          options={skillOptions}
                          styles={skillSelectStyles}
                          onChange={(value) =>
                            handleSkillLevelChange(value, index)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-2 skill-actions">
                      <div
                        className="delete-skill tooltipped tooltipped-n"
                        aria-label="Delete Skill"
                        onClick={() => openDeleteSkillPopup(index)}
                      >
                        <img
                          src="dist/images/delete-icon.svg"
                          alt="delete icon"
                        />
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ) : null}
        <Modal
          className="skill-delete-modal"
          isOpen={isDeleteSkillModalOpen || isBulkDeleteSkillModalOpen}
          onRequestHide={() => closeDeleteSkillPopup()}
        >
          <ModalBody>
            <div>
              <img
                src="dist/images/delete-skill-icon.svg"
                alt="delete skill icon"
              />
              <div className="title">Are you Sure?</div>
              <div className="description">
                Are you sure you want to delete this skill(s)?
              </div>
              <div className="btn-container">
                <button
                  className="cancel-btn"
                  onClick={() => closeDeleteSkillPopup()}
                >
                  Cancel
                </button>
                <button
                  className="delete-skill-btn"
                  onClick={() => {
                    if (isDeleteSkillModalOpen) deleteSkill()
                    if (isBulkDeleteSkillModalOpen) bulkSkillsDelete()
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          className="add-new-skill-modal"
          isOpen={isAddNewSkillPopupOpen}
          onRequestHide={() => setAddNewSkillPopupOpen(false)}
        >
          <ModalBody>
            <div
              className={`add-new-skill-popup ${
                addNewSkillBtnPosition.left && addNewSkillBtnPosition.left < 500
                  ? "show-right"
                  : ""
              }`}
            >
              <div className="heading">
                Add Skill
                <div
                  className="close-new-skill-popup"
                  onClick={() => setAddNewSkillPopupOpen(false)}
                >
                  <span className="icon-cross" />
                </div>
              </div>
              <input
                className="new-skill-input"
                type="text"
                value={newSkillValue}
                placeholder="Enter Skill..."
                onChange={(e) => handleNewSkillChange(e)}
                onKeyDown={(e) => {
                  if (
                    e.target.value !== "" &&
                    (e.keyCode === 13 || e.key === "Enter")
                  ) {
                    let temp = $.extend(true, [], newSkills)
                    temp.push({ skill: newSkillValue })
                    setNewSkills(temp)
                    setNewSkillValue("")
                  }
                }}
              />
              <div className="description">
                <img
                  className="enter-icon"
                  src="dist/images/enter-icon.svg"
                  alt="press enter icon"
                />
                press enter to add
              </div>
              {!_.isEmpty(newSkills)
                ? _.map(newSkills, (skill, index) => {
                    return (
                      <div className="new-skill-container">
                        {skill.skill}
                        <Select
                          className="new-skill-select-options"
                          placeholder="Select Level"
                          options={skillOptions}
                          styles={newSkillSelectStyles}
                          onChange={(value) =>
                            handleNewSkillLevel(value, index)
                          }
                        />
                        <span
                          className="icon-cross"
                          onClick={() => {
                            let temp = $.extend(true, [], newSkills)
                            temp.splice(index, 1)
                            setNewSkills(temp)
                          }}
                        />
                      </div>
                    )
                  })
                : null}
              <div className="btn-container">
                <button
                  aria-label="Add skill proficiency for all skills you have added to submit"
                  className={`submit-btn ${
                    newSkillPopupSubmitBtnDisabled
                      ? "disable-submit-btn tooltipped tooltipped-w"
                      : ""
                  }`}
                  onClick={() =>
                    !newSkillPopupSubmitBtnDisabled && handleNewSkillSubmit()
                  }
                >
                  Submit
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }

  const isVerifyButtonDisabled = () => {
    const { requiredPersonalFields } = getpersonalInfoFields()
    let disabled = false
    requiredPersonalFields.forEach((field) => {
      if (data.personal_information && !data.personal_information[field]) {
        disabled = true
        return
      }
    })
    let { summary, skills } = getSummarySkillsInfo()
    if (skills.isRequired && _.isEmpty(data?.skills?.skills)) disabled = true
    if (summary.isRequired && !data?.summary?.summary) disabled = true
    return disabled
  }

  const isSkillsLimitReached = (limit) => {
    return (
      data["skills"] &&
      data["skills"].skills &&
      data["skills"].skills.length > limit
    )
  }

  isVerifyBtnDisabled = isVerifyButtonDisabled()
  if (skills.maxLimit) {
    skillsLimitReached = isSkillsLimitReached(skills.maxLimit)
  }
  return (
    <div>
      <Modal
        className="verify-candidate-details-modal"
        isOpen={isOpen}
        aria-label={"Verify candiate details modal"}
      >
        <ModalBody>
          <div
            onClick={() => handleClose(true)}
            aria-label={`Click to close this popup`}
            className="close-modal"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.keyCode === 13 || e.key === "Enter") {
                e.preventDefault()
                e.stopPropagation()
                handleClose(true)
              }
            }}
          >
            <span className="icon-cross" />
          </div>
          <div className="verify-candidate-details-container">
            <div className="heading-container">
              {showEditText ? "Edit" : "Verify"} Candidate Details
            </div>
          </div>
          {renderCandidateDetailsContainer(
            skillsLimitReached ? skills.maxLimit : 0
          )}
        </ModalBody>
      </Modal>
      <div className="bottom-container">
        <div className="btn-container">
          <button
            className="decline-btn"
            onClick={() => {
              if (!showLoader) handleClose()
            }}
            disabled={showLoader}
          >
            Decline
          </button>
          <button
            className="verify-btn"
            aria-label={
              skillsLimitReached
                ? `You can have a maximum of ${skills.maxLimit} skills`
                : ""
            }
            disabled={showLoader || isVerifyBtnDisabled || skillsLimitReached}
            onClick={() => handleCandidateDetailsUpdate()}
          >
            {showEditText ? "Save" : "Verify"} Candidate Details
          </button>
        </div>
      </div>
    </div>
  )
}

export default CandidateDetailsVerification
